import { useEffect } from 'react';
/**
 * @function useIf
 * @since 1.0.0
 */
export function useIf(condition, 
// eslint-disable-next-line @typescript-eslint/ban-types
whenTrue, 
// eslint-disable-next-line @typescript-eslint/ban-types
whenFalse) {
    useEffect(() => {
        if (condition) {
            if (whenTrue) {
                whenTrue();
            }
        }
        else {
            if (whenFalse) {
                whenFalse();
            }
        }
    }, [condition]);
}
